//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { Button, Modal } from '@mui/material';
import React, { useState } from 'react';
import { Button as ButtonSection } from 'antd';
import Loading from 'components/Loading';
import { get } from 'lodash';
import { createKeystore } from 'store/keystore/thunks';
import styled from "styled-components"
import { v4 } from 'uuid';


const ModalContent = styled.div`
    align-items: center;
    background-color: #fff;
    border-radius: 3px;
    display: inline-flex;
    flex-direction: column;
    left: 50%;
    max-width: 320px;
    padding: 16px;
    position: absolute;
    text-align: center;
    top: 50%;
    transform: translate(-50%, -50%);
`;

const ModalRow = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 16px;
    width: 100%;
`;

// export default function Login_as({ user }) {
//     const [loginLoader, setLoginAs] = useState(false);
//     const [loginAsModal, setLoginAsModal] = useState(false);
//     const openLoginInNewWindow = async () => {
//         const userId = user.id;
//         setLoginAs(userId);
//         const key = v4()
//         await createKeystore(userId, key)
//         const url = `${window.location.origin}?key=${key}`
//         window.open(url, '_blank', 'toolbar=0,location=0,menubar=0');
//         setLoginAs(null);
//         setLoginAsModal(false)
//     }

export default function Login_as({ user }) {
    const [loginLoader, setLoginAs] = useState(false);
    const [loginAsModal, setLoginAsModal] = useState(false);

    const openLoginInNewWindow = async () => {
        const userId = user.id;
        setLoginAs(userId);
        const key = v4();
        await createKeystore(userId, key);
        const url = `${window.location.origin}?key=${key}`;

        const newWindow = window.open(url, '_blank', 'toolbar=0,location=0,menubar=0');
        
        if (newWindow) {
            newWindow.opener = null;
        } else {
            alert("Pop-up blocked. Please allow pop-ups for this site.");
        }

        setLoginAs(null);
        setLoginAsModal(false);
    }
    const full_name = `${get(user, 'firstName', '')} ${get(user, 'lastName', '')}`
    const user_name = full_name.length<12?full_name:full_name.slice(0,12)+'...'
    return (
        <>
            <Modal
                open={loginAsModal}
                onClose={() => setLoginAsModal(false)}
            >
                <ModalContent>
                    You will  {`Log in as ${user_name}`} , any changes you make will be APPLIED to this account.
                    <ModalRow>
                        <Button
                            color="secondary"
                            style={{ marginRight: '4px' }}
                            onClick={() => {
                                setLoginAsModal(false)
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            color="primary"
                            variant="contained"
                            disabled={loginLoader}
                            onClick={openLoginInNewWindow}
                        >
                            {loginLoader ? <Loading size={20} white /> : `Log in as ${user_name}`}
                        </Button>
                    </ModalRow>
                </ModalContent>
            </Modal>
            <ButtonSection type="default" variant="outlined" style={{ marginLeft: 10 }} disabled={!user?.active || loginLoader} onClick={() => { setLoginAsModal(true) }} >
                {`Log in as ${user_name}`}
            </ButtonSection>
        </>
    )
}
